import { render, staticRenderFns } from "./carwash-book.vue?vue&type=template&id=015afde2&"
import script from "./carwash-book.vue?vue&type=script&lang=js&"
export * from "./carwash-book.vue?vue&type=script&lang=js&"
import style0 from "./carwash-book.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports